$(document).ready(function() {
$(".disclosure__content div").each(function() {
  if ($(this).hasClass("errors")) {
      $(this).closest(".disclosure").find(".disclosure__title").trigger("click");
  }
});
    $('#customer_login label, #recover_email label, #create_customer label').each(function() {
        var labelText = $(this).text();
        $(this).hide();
        $(this).next("input").attr("placeholder", labelText);
    });
});